import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared';
import { Core2Config } from '../shared';
import {AppletToCatalogLinkFileHelperContainerModel} from '../../../../../models/aggregates/upload-applet-to-catalog/applet-to-catalog-link-import-file-helper-container.model';

@Injectable({
  providedIn: 'root'
})
export class AppletToCatalogLinkFileHelperService extends BaseApiTemplateService<AppletToCatalogLinkFileHelperContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'applet-to-catalog-link-import-file-helpers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'applet-to-catalog-link-import-file-helpers/backoffice-ep';
    this.httpClient = http;
  }
}